function num(a: any, b: any): number {
    return (a !== undefined && a !== null) ? a : (b || 0);
}

export class ChatMcpConfigDto {
    public id: number = 0;
    public nombreHerramienta: string = "";
    public descripcion: string = "";
    public habilitado: boolean = true;

    constructor(data?: any) {
        if (!data) { return; }
        this.id               = num(data.Id,   data.id);
        this.nombreHerramienta = data.NombreHerramienta || data.nombreHerramienta || data.nombre_herramienta || "";
        this.descripcion       = data.Descripcion || data.descripcion || "";
        this.habilitado        = data.Habilitado !== undefined ? data.Habilitado : (data.habilitado !== undefined ? data.habilitado : true);
    }
}
